import React from "react";
import { GiSkills } from "react-icons/gi";

import { SkillsList } from "../../constants";

const Skills = ({ theme }) => {
  return (
    <div
      className={`${
        theme === "dark" ? "border-darkLineColor" : "border-lightLineColor"
      } py-10 xl:py-20 border-b-[1px]`}
    >
      <h3
        className={`${
          theme === "dark" ? "text-darkTextColor" : "text-lightTextColor"
        } text-[32px] flex flex-row justify-center lgl:justify-start items-center gap-4 text-center lgl:text-left font-bold`}
      >
        Skills
        <span>
          <GiSkills className="text-iconColor hover:animate-pulse" />
        </span>
      </h3>
      <div className="py-6 w-full flex flex-col gap-10">
        <h3
          className={`${
            theme === "dark"
              ? "text-darkTextColor decoration-darkLineColor"
              : "text-lightTextColor decoration-lightLineColor"
          } text-xl text-center xl:text-left xl:mr-2 underline underline-offset-8 tracking-widest font-bold`}
        >
          Developer Skills:
        </h3>
        <ul className="flex flex-row gap-4 flex-wrap justify-center xl:justify-start">
          {SkillsList.map((skill) => (
            <li
              key={skill.id}
              className={`${
                theme === "dark"
                  ? "text-darkTextColor font-light hover:bg-black"
                  : "text-lightTextColor font-normal hover:border-lightTextDesignColor hover:bg-darkTextDesignColor"
              } skillli cursor-pointer transition-all ease-in-out duration-300 xl:px-6`}
            >
              <a href={skill.link} target="_blank" rel="noreferrer">
                {skill.title}
              </a>
            </li>
          ))}
        </ul>
        <h3
          className={`${
            theme === "dark"
              ? "text-darkTextColor decoration-darkLineColor"
              : "text-lightTextColor decoration-lightLineColor"
          } text-xl text-center xl:text-left xl:mr-2 underline underline-offset-8 tracking-widest font-bold`}
        >
          Developement Skills:
        </h3>
        <ul className="w-full flex flex-col items-center gap-2 -mt-2">
          <li
            className={`${
              theme === "dark"
                ? "text-darkTextColor border-darkLineColor"
                : "text-lightTextColor border-lightLineColor"
            } text-xl w-full flex flex-col xl:flex-row justify-start gap-2 hover:border-b-[1px] h-auto py-2 opacity-75 hover:opacity-100 transition-opacity ease-linear cursor-grab duration-300 group`}
          >
            <span
              className={`${
                theme === "dark"
                  ? "decoration-darkTextColor"
                  : "decoration-lightTextColor"
              } w-full xl:w-1/4 group-hover:underline underline-offset-4 decoration-1`}
            >
              Development of front-end :
            </span>
            <span
              className={`${
                theme === "dark"
                  ? "text-darkTextColor font-light"
                  : "text-lightTextColor font-normal"
              } w-full xl:w-3/4 text-justify`}
            >
              With the help of JavaScript frameworks and npm libraries, I am
              able to build interactive user interfaces.
            </span>
          </li>
          <li
            className={`${
              theme === "dark"
                ? "text-darkTextColor border-darkLineColor"
                : "text-lightTextColor border-lightLineColor"
            } text-xl w-full flex flex-col xl:flex-row justify-start gap-2 hover:border-b-[1px] h-auto py-2 opacity-75 hover:opacity-100 transition-opacity ease-linear cursor-grab duration-300 group`}
          >
            <span
              className={`${
                theme === "dark"
                  ? "decoration-darkTextColor"
                  : "decoration-lightTextColor"
              } w-full xl:w-1/4 group-hover:underline underline-offset-4 decoration-1`}
            >
              Backend Development :
            </span>
            <span
              className={`${
                theme === "dark"
                  ? "text-darkTextColor font-light"
                  : "text-lightTextColor font-normal"
              } w-full xl:w-3/4 text-justify`}
            >
              To create a robust backend architecture for fetching data from the
              servers, I am much more dependent on nodejs, expressjs, firebase,
              MongoDB, or any similar platforms
            </span>
          </li>
          <li
            className={`${
              theme === "dark"
                ? "text-darkTextColor border-darkLineColor"
                : "text-lightTextColor border-lightLineColor"
            } text-xl w-full flex flex-col xl:flex-row justify-start gap-2 hover:border-b-[1px] h-auto py-2 opacity-75 hover:opacity-100 transition-opacity ease-linear cursor-grab duration-300 group`}
          >
            <span
              className={`${
                theme === "dark"
                  ? "decoration-darkTextColor"
                  : "decoration-lightTextColor"
              } w-full xl:w-1/4 group-hover:underline underline-offset-4 decoration-1`}
            >
              Databases and Servers :
            </span>
            <span
              className={`${
                theme === "dark"
                  ? "text-darkTextColor font-light"
                  : "text-lightTextColor font-normal"
              } w-full xl:w-3/4 text-justify`}
            >
              The website & application systems will be resilient to outages and
              will function endlessly. I will ensure the cross-connection
              smoothly.
            </span>
          </li>
          <li
            className={`${
              theme === "dark"
                ? "text-darkTextColor border-darkLineColor"
                : "text-lightTextColor border-lightLineColor"
            } text-xl w-full flex flex-col xl:flex-row justify-start gap-2 hover:border-b-[1px] h-auto py-2 opacity-75 hover:opacity-100 transition-opacity ease-linear cursor-grab duration-300 group`}
          >
            <span
              className={`${
                theme === "dark"
                  ? "decoration-darkTextColor"
                  : "decoration-lightTextColor"
              } w-full xl:w-1/4 group-hover:underline underline-offset-4 decoration-1`}
            >
              API development :
            </span>
            <span
              className={`${
                theme === "dark"
                  ? "text-darkTextColor font-light"
                  : "text-lightTextColor font-normal"
              } w-full xl:w-3/4 text-justify`}
            >
              Depending on the application architecture, I will create the API.
              These APIs will perform crucial tasks like fetching data from the
              server.
            </span>
          </li>
          <li
            className={`${
              theme === "dark"
                ? "text-darkTextColor border-darkLineColor"
                : "text-lightTextColor border-lightLineColor"
            } text-xl w-full flex flex-col xl:flex-row justify-start gap-2 hover:border-b-[1px] h-auto py-2 opacity-75 hover:opacity-100 transition-opacity ease-linear cursor-grab duration-300 group`}
          >
            <span
              className={`${
                theme === "dark"
                  ? "decoration-darkTextColor"
                  : "decoration-lightTextColor"
              } w-full xl:w-1/4 group-hover:underline underline-offset-4 decoration-1`}
            >
              Platform compatibility :
            </span>
            <span
              className={`${
                theme === "dark"
                  ? "text-darkTextColor font-light"
                  : "text-lightTextColor font-normal"
              } w-full xl:w-3/4 text-justify`}
            >
              Applications or Websites will run smoothly on all operating
              systems like Windows, macOS, and Linux.
            </span>
          </li>
          <li
            className={`${
              theme === "dark"
                ? "text-darkTextColor border-darkLineColor"
                : "text-lightTextColor border-lightLineColor"
            } text-xl w-full flex flex-col xl:flex-row justify-start gap-2 hover:border-b-[1px] h-auto py-2 opacity-75 hover:opacity-100 transition-opacity ease-linear cursor-grab duration-300 group`}
          >
            <span
              className={`${
                theme === "dark"
                  ? "decoration-darkTextColor"
                  : "decoration-lightTextColor"
              } w-full xl:w-1/4 group-hover:underline underline-offset-4 decoration-1`}
            >
              Browser compatibility :
            </span>
            <span
              className={`${
                theme === "dark"
                  ? "text-darkTextColor font-light"
                  : "text-lightTextColor font-normal"
              } w-full xl:w-3/4 text-justify`}
            >
              Will be supported in all modern browsers like Chrome, Microsoft
              Edge, Brave, Safari, etc. All the properties will be modified or
              upgraded to make browser friendly.
            </span>
          </li>
          <li
            className={`${
              theme === "dark"
                ? "text-darkTextColor border-darkLineColor"
                : "text-lightTextColor border-lightLineColor"
            } text-xl w-full flex flex-col xl:flex-row justify-start gap-2 hover:border-b-[1px] h-auto py-2 opacity-75 hover:opacity-100 transition-opacity ease-linear cursor-grab duration-300 group`}
          >
            <span
              className={`${
                theme === "dark"
                  ? "decoration-darkTextColor"
                  : "decoration-lightTextColor"
              } w-full xl:w-1/4 group-hover:underline underline-offset-4 decoration-1`}
            >
              Technical requirements :
            </span>
            <span
              className={`${
                theme === "dark"
                  ? "text-darkTextColor font-light"
                  : "text-lightTextColor font-normal"
              } w-full xl:w-3/4 text-justify`}
            >
              I am able to build responsive applications that meet customer
              requirements and keep them engaged.
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Skills;
